/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

export enum CARD_FIELD_NAMES {
  paymentCreditCard = 'paymentCreditCard',
  nameOnCard = 'nameOnCard',
  expMonth = 'expMonth',
  expYear = 'expYear',
  CVV = 'CVV',
  agreementCheckbox = 'agreementCheckbox'
}

export enum BUSINESS_FIELD_NAMES {
  name = 'name',
  signatoryTitle = 'signatoryTitle',
  signatoryFirstName = 'signatoryFirstName',
  signatoryLastName = 'signatoryLastName',
}

export enum BILLING_FIELD_NAMES {
  address1 = 'address1',
  city = 'city',
  stateId = 'stateId',
  postalCode = 'postalCode',
}

export const MAX_LENGTHS = {
  name: 30,
  city: 30,
  address: 250,
  companyName: 30,
  email: 60,
  password: 20,
  secretAnswer: 255,
  cardCVV: 3,
  cardCVVLong: 4,
  promoElc: 50,
  promoEvt: 15,
  transferReason: 2000,
  textarea: 250,
  businessName: 100,
  signatoryTitle: 100,
  cancellationReason: 280
}

export const EFFECTIVE_DATE_INTERVAL_IN_MINUTES = 30

export enum USER_FORMS {
  profileShippingForm = 'profileShippingForm',
  profileBillingForm = 'profileBillingForm',
  profileAddCard = 'profileAddCard',
  profilePaymentDetails = 'profilePaymentDetails',
  profileBusinessDetails = 'profileBusinessDetails',
  contactUsForm = 'contactUsForm',
  forgotPasswordForm = 'forgotPasswordForm',
  cancelSubscription = 'cancelSubscription'
}
